import React from 'react';
import haku_icon from '../../images/Icon-Raw-Black-Transparent.png';
import {useNavigate} from "react-router-dom";
import { isMobile, BrowserView, MobileView } from 'react-device-detect';
import { styles } from './styles';



export enum HeaderPages {
    Home,
    Contact,
    Clients,
    About
}


export interface HeaderProps {
    currentPage: HeaderPages;
}


export const Header: React.FC<HeaderProps> = ({ currentPage }) => {
    const navigate = useNavigate();

    const handleClick = (page: HeaderPages) => {
        if (page === HeaderPages.Home) {
            navigate('/');
        } else if (page === HeaderPages.Clients) {
            navigate('/clients');
        } else if (page === HeaderPages.About) {
            navigate('/about');
        } else if (page === HeaderPages.Contact) {
            navigate('/contact');
        }
    };

    const mobileView = () => {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                color: 'rgb(23, 23, 23)',
                padding: '15px',
                backgroundColor: 'rgb(246, 246, 246)'
            }}>
                <img src={haku_icon} height="40px" style={{}} alt="Haku icon" />
                <div style={{
                    flex: 1,
                    fontSize: '1.5rem',
                    fontWeight: 600,
                    fontFamily: 'Oswald, sans-serif',
                    textAlign: 'center',
                }}>Haku Technology</div>
                <div style={{
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <div style={{
                        height: '3px',
                        width: '75%',
                        backgroundColor: 'rgb(23, 23, 23)',
                        borderRadius: '1.5px'
                    }} />
                    <div style={{
                        height: '3px',
                        width: '75%',
                        backgroundColor: 'rgb(23, 23, 23)',
                        borderRadius: '1.5px',
                        marginTop: '6px',
                        marginBottom: '6px'
                    }} />
                    <div style={{
                        height: '3px',
                        width: '75%',
                        backgroundColor: 'rgb(23, 23, 23)',
                        borderRadius: '1.5px'
                    }} />
                </div>
            </div>
        );
    };

    const browserView = () => {
        return (
            <div style={{...styles.header, ...styles.lightBackground}}>
                <img src={haku_icon} height="40px" style={styles.headerLogo} alt="Haku icon" />
                <div style={styles.headerTitle}>Haku Technology</div>
                <div style={styles.headerContent}>
                    <div
                        style={{...styles.headerLink}}
                        onClick={() => handleClick(HeaderPages.Home)}
                    >
                        Home
                    </div>
                    <div
                        style={{...styles.headerLink}}
                        onClick={() => {
                            window.scrollTo({
                                top: document.documentElement.scrollHeight,
                                behavior: 'smooth'
                            });
                        }}
                    >
                        Clients & Partners
                    </div>
                    <div
                        style={{...styles.headerLink}}
                        onClick={() => {
                            window.location.href = 'mailto:contact@hakutechnology.com';
                        }}
                    >
                        Contact
                    </div>
                    {/*<div*/}
                    {/*    style={{...styles.headerLink}}*/}
                    {/*    onClick={() => handleClick(HeaderPages.About)}*/}
                    {/*>*/}
                    {/*    About*/}
                    {/*</div>*/}
                </div>
            </div>
        );
    };

    return (
        <>
            <MobileView>
                {mobileView()}
            </MobileView>
            <BrowserView>
                {browserView()}
            </BrowserView>
        </>
    );
};


